import { Language, LoctoolTranslation } from "@bigfish/react-loctool";

export const messages: LoctoolTranslation = {
    // eslint-disable-next-line node/no-unpublished-require
    [Language.HU]: require("./locales/hu").localeHU,
};
